<template>
  <div class="container">
    <!-- <theory-practice-page-header /> -->
    <div>
      <path-navigation
        v-if="lesson"
        :paths="[
          {
            name: `Warsztaty - ${lesson.theoryPracticeWorkshop.name}`,
            to: `/warsztaty-teoria-i-praktyka/${lesson.theoryPracticeWorkshop.id}`,
          },
          {
            name: `${lesson.name} - Teoria`,
            to: `/warsztaty-teoria-i-praktyka/${lesson.theoryPracticeWorkshop.id}/lekcje/${this.$route.params.id}/teoria`,
          },
        ]"
      />
      <div class="section-title" style="text-align: center;">
        Anatomia w praktyce
      </div>

      <section>
        <div class="title">
          <svg
            width="50"
            height="50"
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="60" cy="60" r="60" fill="#8B857D" />
            <path
              d="M99.0909 49.7443C100.303 50.2566 100.303 51.0955 99.0909 51.6028L62.7071 66.963C61.2807 67.4747 59.7193 67.4747 58.2929 66.963L21.9091 51.6078C20.697 51.0955 20.697 50.2516 21.9091 49.7443L58.2929 34.3841C59.7193 33.872 61.2807 33.872 62.7071 34.3841L99.0909 49.7443ZM64.5808 71.3555C64.5808 71.3567 64.582 71.3576 64.5832 71.3571L82.71 63.7078C83.652 63.3102 84.697 63.9967 84.697 65.0129V73.322C84.697 80.3241 73.8636 86 60.5 86C47.1364 86 36.3081 80.3241 36.3081 73.322V65.0081C36.3081 63.9918 37.3532 63.3054 38.2952 63.703L56.4192 71.353C59.0429 72.3695 61.9546 72.3698 64.5785 71.3539C64.5796 71.3535 64.5808 71.3543 64.5808 71.3555ZM89.529 78.3647C89.5297 79.1474 90.169 79.7816 90.9573 79.7816H96.3949C97.1838 79.7816 97.8232 79.1466 97.8232 78.3634V74.3015C97.8427 73.7475 97.7497 73.1953 97.55 72.6778C97.3502 72.1603 97.0477 71.6881 96.6605 71.2893C96.2734 70.8906 95.8094 70.5735 95.2963 70.3569C94.7833 70.1403 94.2316 70.0287 93.6742 70.0287C93.1169 70.0287 92.5652 70.1403 92.0521 70.3569C91.5391 70.5735 91.0751 70.8906 90.6879 71.2893C90.3007 71.6881 89.9982 72.1603 89.7985 72.6778C89.5987 73.1953 89.5058 73.7475 89.5252 74.3015L89.529 78.3647ZM93.6717 61.6839C94.2253 61.6848 94.7668 61.5225 95.2276 61.2173C95.6883 60.9122 96.0478 60.4779 96.2603 59.9695C96.4729 59.4611 96.529 58.9015 96.4216 58.3613C96.3142 57.8212 96.0481 57.3249 95.657 56.9352C95.2659 56.5456 94.7674 56.28 94.2245 56.1723C93.6816 56.0645 93.1188 56.1193 92.6072 56.3298C92.0956 56.5402 91.6584 56.8969 91.3507 57.3546C91.043 57.8123 90.8788 58.3505 90.8788 58.9011C90.8788 59.6392 91.1736 60.347 91.6983 60.8688C92.223 61.3907 92.9347 61.6839 93.6768 61.6839H93.6717ZM93.6717 68.7913C94.2251 68.7923 94.7664 68.6301 95.227 68.3252C95.6877 68.0202 96.0471 67.5863 96.2598 67.0782C96.4725 66.5701 96.5289 66.0107 96.422 65.4707C96.315 64.9307 96.0494 64.4344 95.6588 64.0445C95.2682 63.6546 94.7701 63.3887 94.2276 63.2804C93.685 63.172 93.1223 63.2261 92.6107 63.4358C92.099 63.6455 91.6614 64.0014 91.3531 64.4584C91.0449 64.9155 90.8798 65.4532 90.8788 66.0036C90.8781 66.3695 90.95 66.7318 91.0903 67.07C91.2306 67.4082 91.4366 67.7156 91.6965 67.9745C91.9564 68.2335 92.2651 68.4389 92.6049 68.579C92.9446 68.7192 93.3089 68.7913 93.6768 68.7913H93.6717Z"
              fill="white"
            />
          </svg>

          <span class="sub-title">Teoria</span>
        </div>

        <div class="content-section" v-if="theories && theories.length > 0">
          <theory-practice-lesson-theory
            v-for="theory in theories"
            :key="theory.id"
            :theory="theory"
          />
        </div>

        <div
          v-if="attachments && attachments.length > 0"
          class="content-section attachments-section"
        >
          <div class="attachments-header">
            <div class="attachments-icon-wrapper">
              <svg
                class="attachments-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#fff"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
            </div>
            <h3 class="attachments-title">Pliki do pobrania</h3>
          </div>
          <div class="attachments-container">
            <theory-practice-lesson-attachment
              :attachment="attachment"
              v-for="attachment in attachments"
              :key="attachment.id"
              class="attachment-item"
            />
          </div>
        </div>

        <div class="content-section">
          <comment-section
            v-if="lesson"
            :id="lesson ? lesson.id : null"
            :type="'lesson'"
            :lesson="lesson"
            :key="lesson ? lesson.id : new Date()"
            :isTheory="true"
          />
        </div>
      </section>
    </div>

    <div class="flex justify-center text-center" id="lessons-select"></div>
  </div>
</template>

<script>
import { SERVER_URL } from "../../axios";
import CommentSection from "../../components/CommentSection.vue";
import PathNavigation from "../../components/PathNavigation.vue";
import TheoryPracticeLessonAttachment from "./components/TheoryPracticeLessonAttachment.vue";
import TheoryPracticeLessonTheory from "./components/TheoryPracticeLessonTheory.vue";

export default {
  metaInfo: {
    title: "Dagajoga warsztaty - Anatomia w praktyce",
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Dagajoga to szkoła internetowa o wszechstronnym systemie budowania praktyki własnej.\nPraktyka jogi połączona z nowoczesnymi metodami ćwiczeń funkcjonalnych, ćwiczeń wzmacniających.",
      },
      {
        property: "og:image",
        content: "https://dagajoga.pl/wp-content/uploads/2022/02/image-5.png",
      },
    ],
  },
  name: "TheoryPracticeWorkshopLessonTheories",
  data: () => ({
    theories: [],
  }),
  components: {
    PathNavigation,
    TheoryPracticeLessonTheory,
    TheoryPracticeLessonAttachment,
    CommentSection,
  },
  props: {
    path: String,
  },

  async mounted() {
    await this.$store.dispatch(
      "theoryPracticeWorkshopsLessons/fetchTheoryPracticeWorkshopsLesson",
      this.$route.params.id
    );

    this.theories = await this.$store.dispatch(
      "theoryPracticeWorkshopsLessonsTheories/fetchTheoryPracticeWorkshopsLessonsTheories",
      {
        theoryPracticeWorkshopsLessonId: this.$route.params.id,
      }
    );

    await this.$store.dispatch(
      "theoryPracticeWorkshopsLessonsAttachments/fetchTheoryPracticeWorkshopsLessonsAttachments",
      {
        theoryPracticeWorkshopsLessonId: this.$route.params.id,
        type: "THEORY",
      }
    );

    const isPaid = await this.$store.dispatch(
      "theoryPracticeWorkshops/checkUserPaidForWorkshop",
      this.$route.params.workshopId
    );
    if (!isPaid) {
      this.redirectLogin();
    }
  },

  computed: {
    theories() {
      return this.$store.getters[
        "theoryPracticeWorkshopsLessonsTheories/getTheoryPracticeWorkshopsLessonsTheories"
      ];
    },
    lesson() {
      return this.$store.getters[
        "theoryPracticeWorkshopsLessons/getTheoryPracticeWorkshopLesson"
      ];
    },
    attachments() {
      return this.$store.getters[
        "theoryPracticeWorkshopsLessonsAttachments/getTheoryPracticeWorkshopsLessonsAttachments"
      ];
    },
  },
  methods: {
    getImageSrc(lesson) {
      const extension = lesson.imagePath.split(".")[1];

      const src = `${SERVER_URL}lessonsImages/${
        lesson.id
      }.${extension}?d=${new Date().getTime()}`;
      return src;
    },
    redirectLogin(signup) {
      this.$router.push({
        name: "Auth",
        params: { name: "", signup: signup },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 2560px;
  padding: 0 10px !important;
}
.type-content {
  border: 1px solid rgb(0, 0, 0, 0.25);
  padding: 1rem;
  border-radius: 20px;
  margin-bottom: 3rem;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.type-label {
  font-size: 30px;
  font-weight: 500;
}

.lessons {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
}
.title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin: 5px;
}
.title img {
  width: 50px;
}

.content-section {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.attachments-section {
  margin: 2rem auto;
  padding: 1.5rem;
  border-radius: 15px;
  background: #d9d9d9;
  position: relative;
  overflow: hidden;
  box-sizing: border-box; /* Zapewnia, że padding nie zwiększy szerokości */
}

@media (max-width: 768px) {
  .attachments-section {
    padding: 1rem;
    margin: 1.5rem auto;
  }
}

.attachments-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid rgba(139, 90, 43, 0.2);
  position: relative;
  flex-wrap: wrap; /* Pozwala na zawijanie na mniejszych ekranach */
}

.attachments-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  margin-right: 1rem;
  background-color: #8b857d;
  border-radius: 50%;
  transition: all 0.3s ease;
  flex-shrink: 0; /* Zapobiega zmniejszaniu ikony */
}

@media (max-width: 480px) {
  .attachments-icon-wrapper {
    width: 40px;
    height: 40px;
    margin-right: 0.75rem;
  }
}

.attachments-icon-wrapper:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(139, 90, 43, 0.2);
  background-color: rgba(139, 90, 43, 0.15);
}

.attachments-icon {
  width: 20px;
  height: 20px;
  transition: all 0.3s ease;
  color: #fff !important;
}

.attachments-title {
  font-weight: 700;
  font-size: 22px;
  color: #8b857d;
  margin: 0;
  letter-spacing: 0.5px;
  position: relative;
}

@media (max-width: 480px) {
  .attachments-title {
    font-size: 18px;
  }
}

.attachments-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1.5rem;
  padding: 0.5rem;
}

@media (max-width: 640px) {
  .attachments-container {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 1rem;
    padding: 0.25rem;
  }
}

@media (max-width: 480px) {
  .attachments-container {
    grid-template-columns: 1fr; /* Jedna kolumna na bardzo małych ekranach */
  }
}

.attachment-item {
  transition: all 0.3s ease;
  width: 100%; /* Pełna szerokość w swoim gridzie */
}

.attachment-item:hover {
  transform: translateY(-3px);
}

@media (max-width: 480px) {
  .attachment-item:hover {
    transform: translateY(-2px); /* Mniejszy efekt na mobilnych urządzeniach */
  }
}
</style>
